import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "customer" }
const _hoisted_2 = { class: "user-header" }
const _hoisted_3 = { class: "form-group row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Authentication token", -1)
const _hoisted_5 = { class: "col-sm-3" }

import { computed, inject } from 'vue';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  __name: 'Fixflo',
  setup(__props) {

const store = useStore();

const setCustomerDeep = async (payload: {
  path: string;
  data: any;
}) => {
  await store.dispatch('customers/setCustomerDeep', payload);
}

const customer = computed(() => store.getters['customers/current']);

const authToken = computed({
  get: () => { return customer.value.fixflo.authToken},
  set: (val: string) => { setCustomerDeep({path: 'fixflo.authToken', data: val})}
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("fieldset", null, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((authToken).value = $event))
            }, null, 512), [
              [
                _vModelText,
                authToken.value,
                void 0,
                { lazy: true }
              ]
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})